/** SVG Animation Enum
    @readonly
    @enum {string}
*/
export var SVGANIMATIONELEMENT;
(function (SVGANIMATIONELEMENT) {
    SVGANIMATIONELEMENT["ANIMATE"] = "animate";
    SVGANIMATIONELEMENT["ANIMATEMOTION"] = "animateMotion";
    SVGANIMATIONELEMENT["ANIMATETRANSFORM"] = "animateTransform";
    SVGANIMATIONELEMENT["SET"] = "set";
})(SVGANIMATIONELEMENT || (SVGANIMATIONELEMENT = {}));
;
